<template>
  <div
    v-if="showMenuOptions"
    class="tw-absolute tw-bottom-full tw-left-[8px] tw-mb-2 tw-flex tw-w-[244px] tw-flex-col tw-items-center tw-gap-2 tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.25)]"
  >
    <div
      class="tw-left-[16px] tw-top-[-292px] tw-flex tw-w-[244px] tw-flex-col tw-items-center tw-divide-y tw-divide-gray-200 tw-rounded-lg tw-text-white tw-shadow-lg"
    >
      <button
        v-if="enableHousemateGroups && showHousemateGroupTab"
        type="button"
        class="tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100"
        @click="handleMoveToGroup"
      >
        <Users fill-color="#3B4143" />

        <span
          class="tw-font-inter tw-text-[16px] tw-leading-normal tw-text-[#3B4143]"
        >
          <span v-if="selectedCount > 0">Merge into group</span>
          <span v-else>Move all to group</span>
        </span>
      </button>

      <button
        v-if="showShare"
        type="button"
        class="tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100"
        :disabled="isSharing"
        @click="handleShortlistShare"
      >
        <ShareNetwork />

        <span
          class="tw-font-inter tw-text-[16px] tw-leading-normal tw-text-[#3B4143]"
        >
          {{ isLoggedInStudent ? shareShortlistLabel : 'Log in to share' }}
        </span>
      </button>

      <button
        v-if="selectedCount > 0"
        type="button"
        class="tw-flex tw-h-[50px] tw-items-center tw-gap-[8px] tw-self-stretch tw-px-[24px] tw-py-[16px] hover:tw-bg-gray-100 focus-visible:tw-bg-gray-100"
        @click="$emit('remove-selected')"
      >
        <Trash />

        <span
          class="tw-font-inter tw-text-[16px] tw-font-[16px] tw-leading-normal tw-text-[#E7000B]"
        >
          Remove from shortlist
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import ShareNetwork from '@components/Student/SVG/ShareNetwork.vue';
import Users from '@components/Student/SVG/Users.vue';
import Trash from '../SVG/Trash.vue';

export default {
  name: 'ShortlistFloatingMenuOptions',
  components: {
    Users,
    ShareNetwork,
    Trash,
  },
  props: {
    showMenuOptions: { type: Boolean, default: false },
    shareUrl: { type: String, default: null },
    resolveShareUrl: {
      type: Function,
      default: null,
    },
    showShare: {
      type: Boolean,
      default: true,
    },
    selectedCount: { type: Number, default: 0 },
    isLoggedInStudent: { type: Boolean, default: false },
    enableHousemateGroups: { type: Boolean, default: false },
    showHousemateGroupTab: { type: Boolean, default: true },
  },
  emits: [
    'close-floating-menu-options',
    'open-context',
    'move-to-group',
    'share-shortlist',
  ],
  data() {
    return {
      shareShortlistLabel: 'Share Shortlist',
      isSharing: false,
    };
  },
  methods: {
    handleMoveToGroup() {
      // If items are selected, merge only those. Otherwise move everything.
      const mode = this.selectedCount > 0 ? 'merge_selected' : 'move_all';
      this.$emit('move-to-group', { mode });
      this.$emit('close-floating-menu-options');
    },
    async handleShortlistShare() {
      if (!this.isLoggedInStudent) {
        this.$emit('close-floating-menu-options');
        window.location.href = '/account/login';
        return;
      }

      if (this.enableHousemateGroups) {
        this.$emit('share-shortlist');
        this.$emit('close-floating-menu-options');
        return;
      }

      if (this.isSharing) {
        return;
      }

      this.isSharing = true;

      let resolvedShareUrl = this.shareUrl;

      try {
        if (!resolvedShareUrl && typeof this.resolveShareUrl === 'function') {
          resolvedShareUrl = await this.resolveShareUrl();
        }

        if (!resolvedShareUrl) {
          this.shareShortlistLabel = 'Cannot share shortlist';
          return;
        }

        if (navigator.share) {
          await navigator.share({
            title: 'UniHomes',
            text: `View my shortlist using this link:\n${resolvedShareUrl}`,
            url: resolvedShareUrl,
          });

          this.shareShortlistLabel = 'Shared';

          return;
        }

        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(resolvedShareUrl);
          this.shareShortlistLabel = 'Link copied';
        }
      } catch (err) {
        if (err?.name === 'AbortError') {
          return;
        }

        if (err?.code === 'FORBIDDEN_SHARE' || err?.response?.status === 403) {
          this.shareShortlistLabel = 'Cannot share shortlist';
        } else {
          this.shareShortlistLabel = 'Error!';
        }
      } finally {
        this.isSharing = false;

        setTimeout(() => {
          this.$emit('close-floating-menu-options');
          this.shareShortlistLabel = 'Share Shortlist';
        }, 3000);
      }
    },
  },
};
</script>
